class TooltipBtn extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('mouseenter', function() {
      const tip = document.createElement('div');
      tip.className = 'tooltip-floating';
      tip.innerHTML = this.getAttribute('data-tooltip');
      document.body.appendChild(tip);
      const rect = this.getBoundingClientRect();
      tip.style.top  = (rect.bottom + window.scrollY + 4) + 'px';
      tip.style.left = (rect.left + window.scrollX)    + 'px';
    });

    this.addEventListener('mouseleave', function() {
      document.querySelectorAll('.tooltip-floating').forEach(t => t.remove());
    });
  }
}

customElements.define("tooltip-btn", TooltipBtn);

document.addEventListener('DOMContentLoaded', function() {
  var dinamicTableSection = document.querySelector('.product-dinamic-table-wrapper');
  var dinamicTableBlock = document.querySelector('.product_collapse_specs_table');
  if (dinamicTableSection != null && dinamicTableBlock != null) {
    dinamicTableBlock.innerHTML = dinamicTableSection.innerHTML;
  }
});